var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonebg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_49_16958)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#363638"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8677 8.46705L13.1598 8.0778C13.5862 7.94953 14.0447 7.98065 14.4499 8.16535C14.855 8.35005 15.1791 8.67571 15.3617 9.08159L16.2675 11.0945C16.4247 11.4437 16.4685 11.8334 16.3928 12.2087C16.3171 12.5841 16.1256 12.9263 15.8453 13.1874L14.4665 14.4712C14.2817 14.6465 14.4218 15.3296 15.0968 16.4987C15.7725 17.6685 16.2948 18.1311 16.5356 18.0591L18.342 17.5072C18.7081 17.3953 19.1001 17.4007 19.463 17.5226C19.826 17.6445 20.1416 17.8769 20.3657 18.1871L21.6531 19.97C21.9131 20.3301 22.0335 20.7722 21.9919 21.2142C21.9504 21.6563 21.7496 22.0682 21.427 22.3735L20.4318 23.3153C20.1105 23.6194 19.7143 23.8328 19.2835 23.9338C18.8527 24.0349 18.4029 24.02 17.9798 23.8906C15.8946 23.2527 13.9636 21.3597 12.1606 18.2384C10.3536 15.1124 9.6712 12.4756 10.1468 10.3213C10.2427 9.88726 10.4528 9.4866 10.7553 9.16066C11.0578 8.83472 11.4418 8.59529 11.8677 8.46705Z",
    fill: "#E72D38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_49_16958",
    x: -6,
    y: -6,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_49_16958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_49_16958",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonebg);
export default __webpack_public_path__ + "static/media/phonebg.a46b88008df1597c6f28ec1a0de442eb.svg";
export { ForwardRef as ReactComponent };